<template>
  <form
    autocomplete="off"
    @submit.prevent="submitForm"
  >
    <TextInput
      v-model="formData.firstName"
      label="First name"
      :validation-error="errors && 'firstName' in errors && errors.firstName[0]"
    />

    <TextInput
      v-model="formData.lastName"
      label="Last name"
      :validation-error="errors && 'lastName' in errors && errors.lastName[0]"
    />

    <h3 class="text-start font-semibold mb-5">
      Delivery Address
    </h3>

    <TextInput
      v-model="formData.streetAddress"
      label="Street Address"
      :validation-error="errors && 'streetAddress' in errors && errors.streetAddress[0]"
    />

    <TextInput
      v-model="formData.building"
      label="Building"
      :validation-error="errors && 'building' in errors && errors.building[0]"
    />

    <TextInput
      v-model="formData.suburb"
      label="Suburb"
      :validation-error="errors && 'suburb' in errors && errors.suburb[0]"
    />

    <TextInput
      v-model="formData.city"
      label="City"
      :validation-error="errors && 'city' in errors && errors.city[0]"
    />

    <div
      class="input-field"
      :class="{'error': errors && 'province' in errors && errors.province[0]}"
    >
      <label>
        Province
      </label>

      <AppDropdown
        class="profile-form-dropdown"
        :trigger-text="formData.province"
      >
        <template
          v-for="(province, index) in provinces"
          :key="index"
        >
          <AppDropdownItem @click="formData.province = province">
            {{ province }}
          </AppDropdownItem>
        </template>
      </AppDropdown>

      <span
        v-if="errors && 'province' in errors && errors.province[0]"
        class="validation-error-message"
      >
        {{ errors.province[0] }}
      </span>
    </div>

    <TextInput
      v-model="formData.postalCode"
      label="Area Code"
      class="mb-7"
      :validation-error="errors && 'postalCode' in errors && errors.postalCode[0]"
    />

    <AppButton
      :processing="isSubmitting"
      class="btn btn-solid btn-secondary py-3 w-full"
    >
      {{ isSubmitting ? 'Saving' : 'Save' }}
    </AppButton>

    <template v-if="error">
      <p class="text-red-500 bg-red-100 rounded col-span-12 block py-2 mt-6">
        {{ error }}
      </p>
    </template>
  </form>
</template>

<script setup>
import { reactive } from 'vue';

import { provinces } from '@/const.js';
import { AppButton, AppDropdown, AppDropdownItem } from '@/components/app';
import { TextInput } from '@/components/forms/inputs';
import { HttpStatusCode } from 'axios';

import { useFormSubmit, useHttp } from '@/composables';

const { errors, error } = useFormSubmit();

const isSubmitting = defineModel('isSubmitting');

import { useAuthStore } from '@/store/index';

const authStore = useAuthStore();

const emit = defineEmits(['confirm']);

const formData = reactive({
  firstName: authStore.user.firstName || null,
  lastName: authStore.user.lastName || null,
  streetAddress: authStore.user.streetAddress || null,
  building: authStore.user.building || null,
  suburb: authStore.user.suburb || null,
  city: authStore.user.city || null,
  province: authStore.user.province || null,
  postalCode: authStore.user.postalCode || null,
});

const submitForm = async () => {
  errors.value = null;
  error.value = null;
  isSubmitting.value = true;

  const response = await useHttp().put('/profile', formData);

  if (response.statusCode === HttpStatusCode.Ok) {
    authStore.user = response.data;
    emit('confirm');
  } else if (response.statusCode === HttpStatusCode.UnprocessableEntity) {
    errors.value = response.errors;
  } else if (response.statusCode === HttpStatusCode.TooManyRequests) {
    error.value = response.exception;
  } else {
    errors.value = response.errors;
  }

  isSubmitting.value = false;
};
</script>
